import tongji from './tongji';


export default {
    path: 'contract',
    component: () => import('@layout/empty'),
    children: [
        tongji,
      
    ]
}
